const cookiePage = `plus_cookiepage(uid: "blta68b9fc2c77902a4") {
    text
    title
}`;

export default cookiePage;
